import { success } from '@common/alert';
import { errorHandler } from '@common/errors';

const $form = $('#news_letter_form');

$form.submit(function (evt) {
    evt.preventDefault();
    if ($form.parsley().validate()) {
        submitNewsletter().then((res) => {
            success(res.message);
            $form.parsley().reset();
            $form[0].reset();
        })
            .fail(errorHandler);
    }
});

function submitNewsletter() {
    return $.ajax({
        method: $form.attr('method'),
        url: $form.attr('action'),
        data : $form.serialize(),
    });
}
